import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { DashboardFiltersState, Option } from "lib/types/state"
import dayjs from "dayjs"

export const DASHBOARD_DATE_FORMAT = "YYYY-MM-DDTHH:mm"

export const initialDashboardFilters = (): DashboardFiltersState => ({
  filteredDays: 1,
  startDate: dayjs().startOf("day").format(DASHBOARD_DATE_FORMAT),
  endDate: dayjs().format(DASHBOARD_DATE_FORMAT),
  storeGroups: [],
  storeMarkets: [],
  timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
})

export const slice = createSlice({
  name: "dashboardFilters",
  initialState: initialDashboardFilters(),
  reducers: {
    setFilteredDays(state, action: PayloadAction<number>) {
      state.filteredDays = action.payload
    },
    setStartDate(state, action: PayloadAction<string>) {
      state.startDate = action.payload
    },
    setEndDate(state, action: PayloadAction<string>) {
      state.endDate = action.payload
    },
    setSelectedStoreGroups(state, action: PayloadAction<Option[]>) {
      state.storeGroups = action.payload
    },
    setSelectedStoreMarkets(state, action: PayloadAction<Option[]>) {
      state.storeMarkets = action.payload
    },
    setTimeZone(state, action: PayloadAction<string>) {
      state.timeZone = action.payload
    }
  }
})

const { actions, reducer } = slice
export const {
  setFilteredDays,
  setStartDate,
  setEndDate,
  setSelectedStoreGroups,
  setSelectedStoreMarkets,
  setTimeZone
} = actions

export default reducer
